import $ from 'jquery';
import {
  A11y,
  Autoplay,
  Keyboard,
  Lazy,
  Navigation,
  Pagination,
  Swiper,
} from 'swiper/swiper.esm.js';
import {deviceIsMinMd} from '../utilities/media-queries.mjs';

/**
 * Copy from ui/slider.js
 */
export default class Sliders {
  constructor() {
  }

  static initFooterAdvantagesCarousel() {
    const preferReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const $footerAdvantages = $('.footer-advantages-wrapper');

    if ($footerAdvantages.length === 0) {
      return;
    }

    Swiper.use([
      A11y,
      Autoplay,
    ]);

    deviceIsMinMd.addEventListener('change', handleMinMdDevices);
    handleMinMdDevices(deviceIsMinMd);

    function handleMinMdDevices(deviceIsMinMd) {
      if (deviceIsMinMd.matches) {
        // Disable slider
        preferReducedMotion.removeEventListener('change', handlePreferReducedMotionDevices);
        destroySlider();
      } else {
        // Might initialize slider
        preferReducedMotion.addEventListener('change', handlePreferReducedMotionDevices);
        handlePreferReducedMotionDevices(preferReducedMotion);
      }
    }

    function destroySlider() {
      $footerAdvantages[0]?.swiper?.destroy();
    }

    function handlePreferReducedMotionDevices(preferReducedMotion) {
      if (preferReducedMotion.matches) {
        // Disable slider
        destroySlider();
      } else {
        // Initialize slider
        new Swiper($footerAdvantages[0], {
          slidesPerView: 1,
          loop: true,
          speed: 1000,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          breakpoints: {
            540: {
              slidesPerView: 2,
            },
          },
        });
      }
    }
  }

  /**
   * Copy from ui/slider.js->footerCarousel()
   */
  static initFooterCarousel() {
    var $footerCarousels = $('.carousel-slider-holder'),
      $footerSliderTabs = $('.js-footer-tab-social');

    if ($footerCarousels.length) {
      Swiper.use([
        A11y,
        Autoplay,
        Keyboard,
        Lazy,
        Navigation,
        Pagination,
      ]);

      $footerCarousels.each(function() {
        if (swiperIsAlreadyInitilized(this)) {
          return;
        }

        var $this = $(this),
          footerSwiperParams = {
            slidesPerView: 'auto',
            spaceBetween: 20,
            freeMode: true,
            touchEventsTarget: 'wrapper',
            navigation: {
              prevEl: $this.find('.swiper-carousel-prev')[0],
              nextEl: $this.find('.swiper-carousel-next')[0],
            },
            lazy: {
              loadPrevNext: true,
              loadOnTransitionStart: true,
            },
            on: {
              lazyImageLoad: _lazyLoadImage,
            },
          };

        $footerSliderTabs.on('click', function() {
          if (swiperIsAlreadyInitilized($this[0]) === false && swiperIsNotVisible($this) === true) {
            // Initialize | Wait for animation to finish
            setTimeout(function() {
              new Swiper($this[0], footerSwiperParams);
            }, 200);
          }
        });

        if (swiperIsNotVisible($this)) {
          return;
        }

        // Initialize
        new Swiper($this[0], footerSwiperParams);
      });
    }
  }
}

function swiperIsAlreadyInitilized(element) {
  return typeof element.swiper === 'object';
}

function swiperIsNotVisible($element) {
  return $element.filter(':visible').length === 0;
}

function _lazyLoadImage(swiper, slide) {
  var $slide = $(slide);
  var $slideImage = $slide.find('.lazyload-on-slide');

  if ($slideImage.length && $slideImage.hasClass('lazyload') === false) {
    $slideImage.addClass('lazyload');
    $slideImage.removeClass('lazyload-on-slide');
  }
}
